document.addEventListener("DOMContentLoaded", function () {
  const All_Details = document.querySelectorAll(".mobile-tabs details");

  All_Details.forEach((deet) => {
    deet.addEventListener("toggle", toggleOpenOneOnly);
  });

  function toggleOpenOneOnly(e) {
    if (this.open) {
      All_Details.forEach((deet) => {
        if (deet != this && deet.open) deet.open = false;
      });
      var top = this.offsetTop - 150;
      document.body.scrollTo({
        top: top,
        behavior: "instant",
      });
    }
  }

  // Handler that uses various data-* attributes to trigger
  // specific actions, mimicing bootstraps attributes
  const triggers = Array.from(
    document.querySelectorAll('[data-toggle="collapse"]')
  );

  window.addEventListener(
    "click",
    (ev) => {
      const elm = ev.target;
      if (triggers.includes(elm)) {
        ev.preventDefault();
        const selector = elm.getAttribute("href");
        collapse(selector, "toggle");
      }
    },
    false
  );

  const fnmap = {
    toggle: "toggle",
    show: "add",
    hide: "remove",
  };
  const collapse = (selector, cmd) => {
    const targets = Array.from(document.querySelectorAll(selector));
    targets.forEach((target) => {
      target.classList[fnmap[cmd]]("in");
    });
  };

  var accountPopupTrigger = document.querySelector(
    ".account-has-dropdown-inner"
  );
  var accountPopup = document.querySelector(".account-customer-dropdown");
  if (accountPopupTrigger != null && accountPopup != null) {
    accountPopupTrigger.addEventListener("click", function (e) {
      accountPopup.classList.toggle("show");
    });
  }

  document.addEventListener("click", function (e) {
    let el = e.target;

    if (!el.closest(".account-has-dropdown")) {
      if (accountPopup != null) {
        accountPopup.classList.remove("show");
      }
    }
  });
});
